import { h, Fragment } from 'preact'
import { useEffect, useState, useRef } from 'preact/compat'
import { useSelector } from 'react-redux'
import { config } from '../../config'
import styles from './CardinalDDC.module.scss'
import { replaceAll } from '../../helpers/common'
import { paymentSelector } from '../../redux/slice/paymentSlice'
import { cardsSelector } from '../../redux/slice/cardsSlice'
import { cardinalCruiseSelector } from '../../redux/slice/cardinalCruiseSlice'

export default function CardinalDDC() {
  const payment = useSelector(paymentSelector)
  const cards = useSelector(cardsSelector)
  const cardinalCruise = useSelector(cardinalCruiseSelector)
  const { cardinalJwt, isCardinalCollectingData } = cardinalCruise
  const { selectedCard } = cards

  const collectionFormRef = useRef(null)
  const [cardBin, setCardBin] = useState('')

  useEffect(() => {
    const cardNumber = selectedCard ? selectedCard.bin : payment.cardNumber

    setCardBin(replaceAll(cardNumber, ' ', ''))
  }, [payment.cardNumber, selectedCard])

  useEffect(() => {
    if (isCardinalCollectingData) {
      collectionFormRef.current.submit()
    }
  }, [isCardinalCollectingData])

  return (
    <>
      <iframe
        id="cardinal-ddc-iframe"
        title="Cardinal DDC"
        name="collectionFrame"
        height="10"
        width="10"
        className={styles.cardinalDDCIframe}
      />
      <form
        ref={collectionFormRef}
        id="collectionForm"
        target="collectionFrame"
        name="devicedata"
        method="POST"
        action={config.ddcCardinalCruise}
      >
        <input type="hidden" name="Bin" value={cardBin} />
        <input type="hidden" name="JWT" value={cardinalJwt} />
      </form>
    </>
  )
}
